import React from "react";
import {Box} from "@mui/material";

export default function ForestDice(props) {
    const {diceOne, diceTwo} = props;
    const getRandomArbitrary = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
    };
    const colorMatrix = [
        'red',
        'blue',
        'orange',
        'purple',
        ['red', 'orange'],
        ['blue', 'purple']

    ];
    const color = colorMatrix[(diceTwo - 1)];

    const symbolMatrix = [
        ['triangle', 'flag'],
        ['triangle', 'flag'],
        ['crossing', 'path'],
        ['crossing', 'path'],
        ['survey', 'path'],
        ['survey', 'path']
    ]
    const symbol = symbolMatrix[(diceOne - 1)];
    //function to get the first character of the string
    const getFirstCharacter = (string) => {
        return string.charAt(0);
    }
    const checkIfVowel = (word) => {
        let vowelRegex = '^[aieouAIEOU].*'
        return word.match(vowelRegex)

    }
    const surveyVisitorText = (color) => {

        return "Survey visitors on " + color + " trails"

    }
    const drawTrailPath = (color) => {
        let bracket = '[' + getFirstCharacter(color).toUpperCase() + ']';

        return "Draw a " + color + " trail path " + bracket + " in any colored area"

    }


    const drawDivider = (color) => {
        let string = "Draw a divider through a "
        if (checkIfVowel(color)) {
            string = "Draw a divider through an "
        }
        return string + color + " square"

    }

    const drawStartFinishMarker = (color) => {

        let string = "Draw a start or finish marker in a "

        if (checkIfVowel(color)) {
            string = "Draw a start or finish marker in an "
        }
        return string + color + " area"

    }
    const drawDividerLong = (colorOne, colorTwo) => {
        let bracketOne = '[' + getFirstCharacter(colorOne).toUpperCase() + ']';
        let bracketTwo = '[' + getFirstCharacter(colorTwo).toUpperCase() + ']';
        let string = "Draw a divider through";
        let stringOne = " a "
        if (checkIfVowel(colorOne)) {
            stringOne = "  an "
        }

        return [string + stringOne + colorOne + " square  or draw a trail path " + bracketOne + " in any colored area" ,
            string + stringOne + colorTwo + " square or draw a trail path " + bracketTwo + " in any colored area"]

    }
    const drawSurveyLong = (colorOne, colorTwo) => {
        let bracketOne = '[' + getFirstCharacter(colorOne).toUpperCase() + ']';
        let bracketTwo = '[' + getFirstCharacter(colorTwo).toUpperCase() + ']';
        let string = "Survey visitors "
        let stringOne = "on "
        if (checkIfVowel(colorOne)) {
            stringOne = "on "
        }

        return [string + stringOne + colorOne + " trails or  draw a " + colorOne + " trail path " + bracketOne + " in any colored area",
           string + stringOne + colorTwo + " trails or  draw a " + colorTwo + " trail path " + bracketTwo + " in any colored area" ]

    }

    const generatePhrase = (symbolOne, symbolTwo, colorOne, colorTwo = null) => {

        let textOne = ''
        let textTwo = ''
        if (symbolOne === 'survey') {
            textOne = surveyVisitorText(colorOne);
            textTwo = drawTrailPath(colorOne);
        }
        if (symbolOne === 'path') {
            textOne = drawTrailPath(colorOne);

        }
        if (symbolOne === 'crossing') {
            textOne = drawDivider(colorOne);
            textTwo = drawTrailPath(colorOne);

        }
        if (symbolOne === 'triangle') {
            textOne = drawStartFinishMarker(colorOne);


        }
        if (colorTwo !== null) {
            if (symbolOne === 'triangle') {

                textTwo = drawStartFinishMarker(colorTwo);

            }
            if (symbolOne === 'crossing') {
                textOne = drawDividerLong(colorOne, colorTwo)[0];
                textTwo = drawDividerLong(colorOne, colorTwo)[1];

            }
            if (symbolOne === 'survey') {
                textOne = drawSurveyLong(colorOne, colorTwo)[0]

                textTwo = drawSurveyLong(colorOne, colorTwo)[1]
            }


        }
        return {textOne, textTwo}
    }
    let textResults;
    if (diceTwo < 5) {
        textResults = generatePhrase(symbol[0], symbol[1], color)
    }
    if (diceTwo > 4) {
        textResults = generatePhrase(symbol[0], symbol[1], color[0], color[1])
    }
    let {textOne, textTwo} = textResults;
    return (
        <Box className="choiceWrapper">
            {diceTwo < 5 &&
                <>
                    <Box className="choiceContainer">
                        <Box className={`${color}-${symbol[0]} choiceBox`}/>
                        <Box className="choiceOr">or</Box>
                        <Box className={`${color}-${symbol[1]} choiceBox`}/>

                    </Box>
                    <Box className="choiceContainer">
                    </Box>
                    <p style={{margin: "0px 0px"}}>{textOne}</p>
                    {textTwo &&
                        <>
                            <p style={{margin: "5px 0px"}}>or</p>
                            <p style={{margin: "0px 0px"}}>{textTwo}</p>
                        </>
                    }
                </>
            }
            {diceTwo > 4 &&
                <>
                    <Box className="choiceContainer">
                        <Box className={`${color[0]}-${symbol[0]} choiceBox`}/>
                        <Box className="choiceOr">or</Box>
                        <Box className={`${color[0]}-${symbol[1]} choiceBox`}/>

                    </Box>
                    <Box className="choiceContainer lower">


                        <Box className={`${color[1]}-${symbol[0]} choiceBox`}/>
                        <Box className="choiceOr">or</Box>
                        <Box className={`${color[1]}-${symbol[1]} choiceBox`}/>

                    </Box>
                    <p style={{margin: "0px 0px"}}>{textOne}</p>
                    {textTwo &&
                        <>
                            <p style={{margin: "5px 0px"}}>or</p>
                            <p style={{margin: "0px 0px"}}>{textTwo}</p>
                        </>
                    }
                </>
            }

        </Box>
    )

}
